export default __webpack_public_path__ + "2dc335636fc8313eb48c84a83fdd3844.woff";